import Layout from "../../hocs/Layout";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Card, Form, Container } from "react-bootstrap/";
import { TextInput } from "../../components/inputs/Inputs";
import { reset_password } from "../../redux/actions/auth";
import { Circles } from "react-loader-spinner";
import Logo from "../../media/img/abenergia-logo.png";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const ResetPassword = ({ reset_password }) => {
  const {
    register,
    watch,
    handleSubmit,
    getValues,
    formState: { isValid, errors },
  } = useForm({
    mode: "onChange",
    defaultValues: { email: "" },
    resolver: yupResolver(
      Yup.object({
        email: Yup.string()
          .email("Ingrese un correo válido")
          .required("Requerido"),
      })
    ),
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = () => {
    setLoading(true);
    try {
      reset_password(email);
      navigate("/");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const email = watch("email");

  return (
    <Layout>
      <div className="min-vh-100 d-flex align-items-center bg-light">
        <Container>
          <Row className="justify-content-center">
            <Col md={5} lg={4} sm={8} xs={12}>
              <Card className="border-0 shadow-lg rounded-4 overflow-hidden">
                <Card.Header className="bg-white border-bottom-0 pt-5 pb-0 text-center">
                  <h2 className="text-primary fw-bold mb-0">Recuperar contraseña</h2>
                </Card.Header>
                <Card.Body className="p-4 p-md-5">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <p className="text-center text-muted small mb-4">
                      Introduce tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
                    </p>

                    <div className="mb-4">
                      <TextInput
                        register={register}
                        name="email"
                        label="Correo electrónico"
                        error={errors.email?.message}
                      />
                    </div>

                    <div className="d-grid gap-2">
                      {loading ? (
                        <Button className="rounded-pill py-2 shadow-sm" disabled>
                          <div className="d-flex justify-content-center">
                            <Circles
                              type="Oval"
                              color="#fff"
                              width={20}
                              height={20}
                            />
                          </div>
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          className="rounded-pill py-2 fw-bold shadow-sm"
                          disabled={!isValid}
                        >
                          Enviar Email
                        </Button>
                      )}
                    </div>
                  </form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default connect(null, {
  reset_password,
})(ResetPassword);
